import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login.component';

import { AffiliateCookieSetterComponent } from './components/public/affiliateCookieSetter/affiliateCookieSetter.component';
import { RouteQueryGuard } from './v2/guards/route-query.guard';
import { WaiverSignComponent } from './v2/components/public/waiver-builder/waiver-sign.component';
import { WaiverSignRedirectComponent } from './v2/components/public/waiver-builder/waiver-sign-redirect.component';
import { EnvelopeSignComponent } from './v2/components/public/waiver-builder/envelope-sign.component';

const routes: Routes = [
  {
    path: '', redirectTo: 'login', pathMatch: 'full'
  },
  {
    path: 'login', component: LoginComponent
  },
  {
    path: 'affiliate/:af', component: AffiliateCookieSetterComponent
  },
  {
    path: 'affiliate/:af/:co', component: AffiliateCookieSetterComponent
  },
  {
    path: 'waiver',
    loadChildren: () => import('./waiver/waiver.module').then(m => m.WaiverModule)
  },
  {
    path: 'sign-waiver/:waiverId', component: WaiverSignComponent,
  },
  {
    path: 'w/:payload', component: WaiverSignRedirectComponent,
  },
  {
    path: 'envelope/:envelopeId', component: EnvelopeSignComponent,
  },
  {
    path: 's/:token',
    loadComponent: () => import('./components/public/short-link-redirect/short-link-redirect.component')
      .then(m => m.ShortLinkRedirectComponent)
  },
  {
    path: 'legal',
    loadChildren: () => import('./components/public/legal/legal.module').then(m => m.LegalModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./v2/components/public/company-registration/company-registration.module')
      .then(m => m.CompanyRegistrationModule)
  },
  {
    path: 'book/:templateID',
    canActivate: [RouteQueryGuard],
    loadChildren: () => import('./v2/components/public/booking-flow-public.module')
      .then(m => m.BookingFlowPublicModule)
  },
  {
    path: 'demo-booking',
    loadComponent: () => import('./v2/components/public/demo-booking/demo-booking.component')
      .then(m => m.DemoBookingComponent)
  },
  {
    path: '',
    loadChildren: () => import('./partner/partner.module').then(m => m.PartnerModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
